import {api} from '../utils'

export default {
    getNeedYourAttention: (branchId, params) => api.get(`/branches/${branchId}/dashboard/needs-attention`, {params}),
    getOrganizationAtGlance: (branchId, params) => api.get(`/branches/${branchId}/dashboard/summary`, {params}),
    getTodaysScheduleOverview: (branchId, params) => api.get(`/branches/${branchId}/dashboard/schedule-overview`, {params}),
    getServiceAgreements: (branchId, params) => api.get(`/branches/${branchId}/dashboard/service-agreements`, {params}),
    getClients: (branchId, params) => api.get(`/branches/${branchId}/dashboard/clients`, {params}),
    getCaregivers: (branchId, params) => api.get(`/branches/${branchId}/dashboard/caregivers`, {params}),
}
